import React, { useEffect, useState } from 'react'
import style from './style.module.scss'
import MyImage from '@shared/components/myImage'
import FlagTeam from '@assets/images/placeholder/team-placeholder.jpg'
import CustomLink from '@shared/components/customLink'
import day from '@assets/images/ipl/day.svg'
import night from '@assets/images/ipl/night.svg'
import PropTypes from 'prop-types'
import { getImgURL } from '@shared-submodule/utils'
import Image from 'next/future/image'
import NoData from '@shared/components/noData'
import usePolling from '@shared/hooks/usePolling'
import { GET_IPL_DATA } from '@graphql/ipl/ipl'
import queryGraphql from '@shared/components/queryGraphql'

function Fixtures({ fixture, filterFn, activeTab }) {
  const [fixtures, setFixtures] = useState(fixture)
  const getTimeIcon = (timestamp) => {
    const matchTime = new Date(timestamp)
    const hours = matchTime.getHours()
    const minutes = matchTime.getMinutes()

    if ((hours > 6 && hours < 18) || (hours === 18 && minutes <= 30)) {
      return <Image unoptimized={true} src={day} alt="Day Icon" width={18} height={18} className='mx-2' layout='raw' />
    }
    return <Image unoptimized={true} src={night} alt="Night Icon" width={18} height={18} className='mx-2' layout='raw' />
  }

  async function pollingCallback() {
    try {
      const allData = await queryGraphql(GET_IPL_DATA, {
        input: { iSeriesId: '67946fd3a867d4fa473c2b43' }
      })
      return allData?.data?.getMajorSeriesData?.aFixtures
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  usePolling(async () => {
    const data = await pollingCallback()
    setFixtures(filterFn(data, activeTab))
  }, { deps: [activeTab] })

  useEffect(() => {
    setFixtures(fixture)
  }, [fixture])
  return (<>
    <div className={`d-md-flex d-none justify-content-center ${style.gridContainer}`}>
      {fixtures.length ? (fixtures?.map((match, i) => {
        return (
          <CustomLink href={`${match?.oSeo?.sSlug}`} key={i}>
            <a>
              <div className={style.gridBox} >
                <div className={style.themeImg}>
                  <div className={style.format}>

                  <span style={{ fontWeight: '700' }}>{`${match?.matchFormatType || match?.sSubtitle?.includes('Match') ? 'T20' : ''} ${match?.sSubtitle?.includes('Match') ? match?.sSubtitle.slice(6) : match?.sSubtitle} ${['Eliminator', 'Final', 'Qualifier'].some(keyword => match?.sSubtitle?.includes(keyword)) ? '' : 'of 74'}`}</span>

                    <span className='fs-2'>․</span>
                    <span style={{ fontWeight: '500' }}>{`${match?.oVenue?.sName}`}</span>
                  </div>
                </div>
                <div className={style.scoreSection}>
                  <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div className='d-flex flex-row gap-3 align-items-center'>
                      <MyImage src={getImgURL(match?.oTeamScoreA?.oTeam?.oImg?.sUrl) || FlagTeam} alt='Team Name' width={34} height={34} className='rounded-circle' />
                      <span className={style.teamScore}>{match?.oTeamScoreA?.oTeam?.sAbbr}</span>
                    </div>
                    <div className={match?.sStatusStr === 'scheduled' ? style.date : style.teamScore}>
                    {match?.sStatusStr === 'scheduled' ? (
                      new Date(match?.dStartDate).toLocaleString('en-US', {
                        weekday: 'short',
                        day: 'numeric',
                        month: 'short'
                      })) : (
                          <p className={` mb-0 ${match?.iWinnerId === match?.oTeamScoreA?.oTeam?._id ? style.win : style.normal}`}>{match?.oTeamScoreA?.sScoresFull}</p>
                    )}</div>
                  </div>
                  <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div className='d-flex flex-row gap-3 align-items-center'>
                      <MyImage src={getImgURL(match?.oTeamScoreB?.oTeam?.oImg?.sUrl) || FlagTeam} alt='Team Name' width={34} height={34} className='rounded-circle' />
                      <span className={style.teamScore}>{match?.oTeamScoreB?.oTeam?.sAbbr}</span>
                    </div>
                    <div className={match?.sStatusStr === 'scheduled' ? style.time : style.teamScore}>
                      {match?.sStatusStr === 'scheduled' ? getTimeIcon(match?.dStartDate) : null}
                      {match?.sStatusStr === 'scheduled' ? new Date(match?.dStartDate).toLocaleString('en-US', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      }) : (
                          <p className={` mb-0 ${match?.iWinnerId === match?.oTeamScoreB?.oTeam?._id ? style.win : style.normal}`}>{match?.oTeamScoreB?.sScoresFull}</p>
                      ) }</div>
                  </div>
                  {match?.sStatusStr === 'completed' && (<>
                    <p className={`${style.status} text-success`}>{match?.sStatusNote}</p>
                    </>)}
                </div>
              </div>
            </a>
          </CustomLink>)
      })) : (
          <NoData title='Stay tuned! The next match goes live soon.' />
      )}
    </div>
    <div className={`d-flex d-md-none flex-column ${style.mwebFixture}`}>
      {fixtures?.length ? (fixtures.map((fixture, i) => {
        return (
          <CustomLink href={`${fixture?.oSeo?.sSlug}`} key={i}>
            <a>
              <div key={i} id={fixture?.dStartDate} className={`${style.match} d-flex justify-content-between align-items-center`}>
                <div className="d-flex flex-row align-items-center justify-content-start text-center gap-2">
                  <Image unoptimized={true} src={getImgURL(fixture?.oTeamScoreA?.oTeam?.oImg?.sUrl)} alt={fixture?.oTeamScoreA?.oTeam?.sAbbr} height={35} width={35} layout='raw' />
                  <div className="d-flex flex-column text-start">
                    <h6 className="my-0 mt-1">{fixture?.oTeamScoreA?.oTeam?.sAbbr || ''}</h6>
                    {fixture?.oTeamScoreA?.sScores && (
                      <span className={`${style.score} ${fixture?.iWinnerId === fixture?.oTeamScoreA?.oTeam?._id ? style.win : style.normal}`}>
                        {fixture?.oTeamScoreA?.sScores || ''} {`(${fixture?.oTeamScoreA?.sOvers || ''})`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex flex-column text-center gap-1" style={{ width: '-webkit-fill-available' }}>
                  <span className={style.status}>
                    {fixture?.sStatusStr === 'live' ? 'Live' : new Date(fixture?.dStartDate).toLocaleString('en-US', {
                      day: 'numeric',
                      month: 'short'
                    }) || ''}
                  </span>
                  <span className={style.place}>
                    {fixture?.oVenue?.sLocation}
                  </span>
                  <span className={style.time} style={{ fontWeight: '600' }}>
                    {fixture?.sStatusStr === 'live' || fixture?.sStatusStr === 'completed' ? '' : `${new Date(fixture?.dStartDate).toLocaleString('en-US', {
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true
                    })}IST` || ''}
                  </span>
                </div>
                <div className="d-flex flex-row justify-content-end align-items-center text-center gap-2">
                  <div className="d-flex flex-column text-end">
                    <h6 className="my-0 mt-1">{fixture?.oTeamScoreB?.oTeam?.sAbbr || ''} </h6>
                    {fixture?.oTeamScoreB?.sScores && (
                      <span className={style.score}>
                        {fixture?.oTeamScoreB?.sScores || ''} {`(${fixture?.oTeamScoreB?.sOvers || ''})`}
                      </span>
                    )}
                  </div>
                  <Image unoptimized={true} src={getImgURL(fixture?.oTeamScoreB?.oTeam?.oImg?.sUrl)} alt={fixture?.oTeamScoreB?.oTeam?.sAbbr} height={35} width={35} layout='raw' />
                </div>
              </div>
            </a>
          </CustomLink>
        )
      }
      )) : (
          <NoData title='Stay tuned! The next match goes live soon.' />
      )}
    </div>
  </>
  )
}

Fixtures.propTypes = {
  fixture: PropTypes.array,
  isMobile: PropTypes.bool,
  filterFn: PropTypes.func,
  activeTab: PropTypes.string
}

export default Fixtures
